import { useCallback, useEffect, useState } from "react";
import customConfig from "../../config";
import {
  getInAppNotificationById,
  getInAppNotificationErrorMessage,
  mapInAppNotificationDetailForUi,
  resolveNotificationTargetUserCount,
} from "../../action/inAppNotification";

export const useNotificationDetail = (
  notificationId,
  { fallbackTargetUserCount } = {},
) => {
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  const fetchNotification = useCallback(async () => {
    if (!notificationId) {
      setLoadError("Notification ID is required");
      setNotification(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setLoadError("");

    try {
      const response = await getInAppNotificationById(notificationId);
      const mapped = mapInAppNotificationDetailForUi(response?.data);
      const enriched = await resolveNotificationTargetUserCount(
        mapped,
        fallbackTargetUserCount,
      );
      setNotification(enriched);
    } catch (error) {
      setLoadError(
        getInAppNotificationErrorMessage(error, customConfig.FETCH_FAILURE),
      );
      setNotification(null);
    } finally {
      setLoading(false);
    }
  }, [fallbackTargetUserCount, notificationId]);

  useEffect(() => {
    fetchNotification();
  }, [fetchNotification]);

  return { notification, loading, loadError, refetch: fetchNotification };
};
